/*
 * @Desc: 
 * @Version: v1.00
 * @Author: Forjune
 * @Date: 2025-03-26 14:00:31
 * @LastEditors: Forjune
 * @LastEditTime: 2025-09-23 15:59:34
 */
import VueRouter from "vue-router";
import Vue from "vue";
import routes from "./routes";

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
Vue.use(VueRouter);

let mode = "hash";
if (process.env.NODE_ENV === "production") {
  mode = "history";
}

const router = new VueRouter({
  routes,
  mode,
  base: "/",
  scrollBehavior: () => ({ y: 0 }), //滚动到顶端
});

export default router;
